export default {
  title: {
    en: 'Yay!',
  },
  text: {
    en: 'Your subscription is up + running. Modify your next order within 12 hours, before we ship your delivery.',
  },
}
